var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var WhiteLabelSettings = /** @class */ (function (_super) {
    __extends(WhiteLabelSettings, _super);
    function WhiteLabelSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve white-label settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/white-label_settings/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    WhiteLabelSettings.prototype.find = function () {
        return this.rawFind().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve white-label settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/white-label_settings/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    WhiteLabelSettings.prototype.rawFind = function () {
        return this.client.request({
            method: 'GET',
            url: '/white-label-settings',
        });
    };
    /**
     * Update white-label settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/white-label_settings/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    WhiteLabelSettings.prototype.update = function (body) {
        return this.rawUpdate(Utils.serializeRequestBody(body, {
            type: 'white_label_settings',
            attributes: ['custom_i18n_messages_template_url'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update white-label settings
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/white-label_settings/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    WhiteLabelSettings.prototype.rawUpdate = function (body) {
        return this.client.request({
            method: 'PUT',
            url: '/white-label-settings',
            body: body,
        });
    };
    WhiteLabelSettings.TYPE = 'white_label_settings';
    return WhiteLabelSettings;
}(BaseResource));
export default WhiteLabelSettings;
//# sourceMappingURL=WhiteLabelSettings.js.map